import React from 'react';
import PropTypes from 'prop-types';
import Loading from '../../../shared/loading';
import defaultOnErrorHandler from '../../../shared/default-on-error-handler';
import Validator from '../../../shared/validator';
import mutate from '../../../shared/mutate';
import { UserSearchControl } from '../shared/user-search-control';

/* Props:
- orderDidSave  Callback after order was saved
*/
export default class LinkLivewireEventOrderModal extends React.Component {
  static propTypes = {
    orderDidSave: PropTypes.func.isRequired,
  };

  constructor(props, context) {
    super(props, context);

    this.validator = new Validator({
      userRequired: state => !!state.user,
    });
    this.state = {
      order: {},
      user: null,
      validations: this.validator.getValidations(),
    };
  }

  componentDidMount() {
    const self = this;

    this.$modal.click(function onClick(e) {
      if (e.target === this) self.dismiss();
    });
  }

  handleUserChange(user) {
    this.setState(oldState => mutate(oldState, state => {
      state.user = user;
      state.validations.userRequiredValid = this.validator.validateUserRequired(state);
    }));
  }

  present(order) {
    this.setState({
      order,
      user: null,
      validations: this.validator.getValidations(),
    });
    this.userSearchControl.clear();
    this.$overlay.fadeIn();
    this.$modal.fadeIn();
  }

  dismiss() {
    this.$overlay.fadeOut();
    this.$modal.fadeOut();
  }

  link() {
    this.setState(
      state => ({
        validations: this.validator.validateForm(state),
      }),
      () => {
        if (!this.validator.formValid) return;

        this.loading.start();
        this.state.order.linkToUser(this.state.user)
          .then(() => {
            this.loading.stop();
            this.dismiss();
            this.props.orderDidSave && this.props.orderDidSave(this.state.order);
          })
          .catch(e => {
            this.loading.stop();
            defaultOnErrorHandler(e, 'Error linking order to user');
          });
      },
    );
  }

  render() {
    return (
      <div>
        <div className="modal-overlay" role="region" ref={el => (this.$overlay = $(el))} onClick={() => this.dismiss()} />
        <div className="modal" tabIndex="-1" role="dialog" ref={el => (this.$modal = $(el))}>
          <article>
            <Loading ref={c => (this.loading = c)}>
              <header>
                <h4>Link order</h4>
              </header>
              <section>
                <form>
                  <p className="form-group">
                    Select the user matching
                    {' '}
                    <strong>
                      {`${this.state.order.name} (${this.state.order.email})`}
                    </strong>
                    {', order number '}
                    <strong>{this.state.order.order_number}</strong>
                    :
                  </p>
                  <div className={`form-group ${this.state.validations.userRequiredValid ? '' : 'has-error'}`}>
                    <UserSearchControl
                      ref={c => (this.userSearchControl = c)}
                      onUserSelected={user => this.handleUserChange(user)}
                    />
                    {this.state.validations.userRequiredValid || <span className="help-block">User is required</span>}
                  </div>
                </form>
              </section>
              <footer>
                <button type="button" className="btn btn-secondary" onClick={() => this.dismiss()}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={() => this.link()}>Link</button>
              </footer>
            </Loading>
          </article>
        </div>
      </div>
    );
  }
}
